import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import React from 'react';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose(): void;
    modalHeader:string;
    isCancelBtnDisable: boolean;
    isConfirmBtnDisable: boolean;
    isConfirmBtnLoading: boolean;
    onClickConfirmBtn(): void;
    modalContent: React.ReactNode
}

function ConfirmationModal({ isOpen,modalHeader, onClose , isCancelBtnDisable, isConfirmBtnDisable, isConfirmBtnLoading, onClickConfirmBtn, modalContent }: ConfirmationModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
    <ModalOverlay className='confirmation-modal__overlay' />
    <ModalContent className='confirmation-modal'>
      <ModalHeader className='confirmation-modal__header'>
      {modalHeader}
        <button className='transfer-create-modal__close-btn' onClick={onClose}><img src='/images/ui/close.svg' /></button>
      </ModalHeader>
      <ModalBody className='confirmation-modal__body' padding="40px 38.5px">
      {modalContent}
      </ModalBody>
      <ModalFooter className='confirmation-modal__footer'>
        <Button
          className='confirmation-modal__secondary-btn'
          isDisabled={isCancelBtnDisable}
          onClick={onClose}
        >
          No
        </Button>
        <Button
          onClick={onClickConfirmBtn}
          isLoading={isConfirmBtnLoading}
          isDisabled={isConfirmBtnDisable}
          className='confirmation-modal__primary-btn'
        >
          Yes
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
  )
}

export default ConfirmationModal